import React, {
  FC, useCallback, useEffect, useMemo, useState,
} from 'react';

import { AffectedQuestions } from '../../commons/AffectedQuestions';
import { QBackButton } from '../../commons/QBackButton';
import { QConfirmButton } from '../../commons/QConfirmButton';
import { QHeader } from '../../commons/QHeader';

import { Q11Form, Q11Response } from './form';
import { Row } from 'components/base/Row';
import { BudgetQuestionCodes } from 'modules/budget/data/budgetQuestionCodes';
import { useBudget } from 'modules/budget/hooks/useBudget';
import { Article } from 'modules/budget/models/Article';
import { isBoolean } from 'utils/helpers';

export const Q11: FC<Record<string, unknown>> = () => {
  const question = BudgetQuestionCodes.Q11;
  const { RespondQuestion } = useBudget();

  const [selectedArticles, setSelectedArticles] = useState<Article[] | null>([]);
  const [dismissService, setDismissService] = useState<boolean>();
  const [autorespond, setautorespond] = useState<boolean>(false);

  const canConfirm = useMemo(
    () => {
      if (selectedArticles) {
        return dismissService || selectedArticles?.length > 0;
      }

      return false;
    },
    [dismissService, selectedArticles],
  );

  const response = useCallback(
    ({ gotoSummary }) => {
      RespondQuestion({
        gotoSummary,
        question,
        response: {
          articles: selectedArticles || [],
        },
      });
    },
    [RespondQuestion, question, selectedArticles],
  );

  const onChange = useCallback(
    (responseData: Q11Response) => {
      setDismissService(isBoolean(responseData.dismissService)
        ? responseData.dismissService
        : undefined);
      setSelectedArticles(responseData.articles);
      setautorespond(responseData.autorespond);
    },
    [],
  );

  useEffect(
    () => {
      if (autorespond && canConfirm) {
        setautorespond(false);
        response({ gotoSummary: false });
      }
    },
    [autorespond, canConfirm, response],
  );

  return (
    <React.Fragment>
      <QHeader question={question} />
      <Q11Form
        question={BudgetQuestionCodes.Q11}
        onChange={onChange}
      />
      <Row justifyContent="space-between">
        <QBackButton question={question} />
        <Row
          className="f-question-actions"
          justifyContent="flex-end"
        >
          <AffectedQuestions
            question={question}
            response={{
              articles: selectedArticles,
            }}
          />
          <QConfirmButton
            disabled={!canConfirm}
            question={question}
            onClick={(payload) => response({ gotoSummary: payload?.gotoSummary })}
          />
        </Row>
      </Row>
    </React.Fragment>
  );
};
